<template>
    <v-bottom-sheet
        v-bind="modal.modalAttrs"
        v-model="visibility"
        :attach="attachTo"
        :style="modal.modalAttrs.style">
        <component
            :is="modal.component"
            v-bind="modal.componentAttrs"
            @close="visibility = false" />
    </v-bottom-sheet>
</template>

<script>
export default {
    name: 'ModalBottomlWrapper',
    emits: ['close'],
    props: {
        modal: {
            type: Object,
            default: () => {
                return {};
            },
        },
        attachTo: {
            type: String,
            default: '#app',
        },
    },
    data() {
        return {
            visibility: false,
        };
    },
    watch: {
        visibility: function (newValue) {
            if (!newValue) {
                !this.modal.events.beforeClose || this.modal.events.beforeClose();
                setTimeout(() => {
                    !this.modal.events.close || this.modal.events.close();
                    this.$emit('close');
                }, 200);
            }
        },
    },
    mounted() {
        this.visibility = true;
    },
};
</script>
